import { Form, InputNumber, Modal } from 'antd';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { investorAccountWithdrawAction } from '~Investors/actions';

interface IState {
    amount: number;
}

interface IProps {
    accountUuid: string;
    onClose: () => void;
    show: boolean;
}

interface IPropsDispatch {
    withdraw: (amount: number) => void;
}

type Props = IProps & IPropsDispatch;    

class WithdrawModal extends React.Component<Props, IState> {
    public state: IState = {
        amount: null,
    };

    constructor(props: Props) {
        super(props);

        this.onChangeAmount = this.onChangeAmount.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    public render(): JSX.Element {
        const { show } = this.props;
        const { amount } = this.state;

        const currencyFormatter = new Intl.NumberFormat('en-AU', {
            currency: 'AUD',
            style: 'currency',
        });

        return (
            <Modal
                onCancel={this.props.onClose}
                onOk={this.onClickOk}
                open={show}
                title='Withdraw'
                wrapClassName='investor-top-up-modal'
            >
                <Form.Item className='amount' extra={currencyFormatter.format(amount)} label='Amount'>
                    <InputNumber addonBefore='$' min={0} onChange={this.onChangeAmount} value={amount} placeholder='0' />
                </Form.Item>
            </Modal>
        );
    }

    private onChangeAmount(value: number): void {
        this.setState({
            amount: value ? _.round(value, 2) : null,
        });
    }

    private onClickOk(): void {
        const { amount } = this.state;

        this.props.withdraw(amount);
        this.props.onClose();
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        withdraw: (amount: number) => dispatch(investorAccountWithdrawAction(ownProps.accountUuid, amount)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(WithdrawModal);
